import { useTranslation } from 'react-i18next';
import UtilityDrawerBody from '../utility-drawer/utility-drawer-body/utility-drawer-body.component';
import UtilityDrawer from '../utility-drawer/utility-drawer.component';
import BrandLoyaltyApiDefinitions from './brand-loyalty-api-definitions/brand-loyalty-api-definitions.component';

type BrandLoyaltyAPIDetailsDrawerProps = {
  isOpen: boolean;
  close: () => void;
};

const BrandLoyaltyAPIDetailsDrawer = ({
  isOpen,
  close,
}: BrandLoyaltyAPIDetailsDrawerProps) => {
  const { t } = useTranslation();
  return (
    <UtilityDrawer
      open={isOpen}
      onClose={close}
      title={t('page.loyaltyPerformanceReport.tabs.brandLoyaltyOverview.label')}
    >
      <UtilityDrawerBody>
        <BrandLoyaltyApiDefinitions />
      </UtilityDrawerBody>
    </UtilityDrawer>
  );
};

export default BrandLoyaltyAPIDetailsDrawer;
